










































import Vue from 'vue';
import moment from 'moment';
import Reschedule from './Reschedule.vue';
import { reactive, onMounted, computed } from '@vue/composition-api';
import { eventBus } from '../main';

export default Vue.extend({
  components: { Reschedule },
  props: {
    scheduled: { type: Array },
    icon: { type: String, default: 'replay' },
    status: { type: Object },
    resourceType: { type: String },
    alertType: { type: String, default: 'info' },
    iconColor: { type: String, default: 'black' },
    client: { type: String, default: '' },
    dataSource: { type: String, default: '' },
    enabled: { type: Boolean, default: false },
    showModifiedUntil: { type: Boolean, default: false },
    disableScheduling: { type: Boolean, default: false },
  },
  setup(props) {
    const state = reactive({
      dialog: false,
    });

    onMounted(() => eventBus.$on('schedule', () => (state.dialog = false)));

    const title = computed(() =>
      props.disableScheduling
        ? `Backfill ${props.dataSource}`
        : `Schedule ${props.dataSource} Sync`,
    );

    return { state, title };
  },
});
